import OrderPurchaseDetails from '../components/OrderPurchaseDetails';
import {ChevronLeft,ChevronRight,X} from 'lucide-react';
import OrderFilters,{EMPTY_ORDER_FILTERS} from '../components/OrderFilters';
import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { ordersAPI, clientsAPI, catalogAPI, placesAPI, promotionsAPI, growthAPI } from '../services/api';
import { ShoppingCart, CheckCircle, XCircle, Search, Eye, Plus, Trash2 } from 'lucide-react';
import Pagination from '../components/Pagination';
import SearchableSelect from '../components/SearchableSelect';
import toast from 'react-hot-toast';

import './OrderBenefits.css';
import {useAuth} from '../hooks/useAuth';

const PAGE_SIZES = [50, 100, 200];


export function CreateOrderModal({ onClose, onCreated }) {
  const [form, setForm] = useState({ phone: '', hold_amount: '0', promo_code: '', external_order_id: '' });
  const [giftChecked,setGiftChecked]=useState(null),[giftBusy,setGiftBusy]=useState(false);
  const giftVersion=useRef(0);
  const [items, setItems] = useState([]);
  const [applyPromotions,setApplyPromotions]=useState(false),[benefitQuote,setBenefitQuote]=useState(null),[quoting,setQuoting]=useState(false);
  const benefitVersion=useRef(0);
  const [benefitPlaces,setBenefitPlaces]=useState([]);
  useEffect(()=>{if(!applyPromotions)return;let alive=true;placesAPI.list().then(({data})=>{if(alive)setBenefitPlaces(Array.isArray(data)?data:data.items||[]);}).catch(()=>{});return()=>{alive=false;};},[applyPromotions]);
  useEffect(()=>{setBenefitQuote(null);benefitVersion.current++;},[form,items,applyPromotions]);
  useEffect(()=>{setGiftChecked(null);giftVersion.current++;},[form,items,applyPromotions]);
  const [products, setProducts] = useState([]);
  const [productSearch, setProductSearch] = useState('');
  const [loading, setLoading] = useState(false);


  useEffect(() => {
    const t = setTimeout(() => {
      const url = productSearch
        ? `/catalog/products?skip=0&limit=50&search=${encodeURIComponent(productSearch)}`
        : `/catalog/products?skip=0&limit=50`;
      catalogAPI.products(0, 50, null, productSearch || null, false)
        .then(r => setProducts(r.data.items || []))
        .catch(() => {});
    }, 300);
    return () => clearTimeout(t);
  }, [productSearch]);

  const addItem = () => {
    setItems([...items, { product_id: '', name: '', price: 0, quantity: 1 }]);
  };

  const updateItem = (idx, field, value) => {
    const newItems = [...items];
    newItems[idx][field] = value;
    if (field === 'product_id') {
      const prod = products.find(p => p.id === value);
      if (prod) {
        newItems[idx].name = prod.name;
        newItems[idx].price = prod.price || 0;
        newItems[idx]._product = prod;
      }
    }
    setItems(newItems);
  };

  const removeItem = (idx) => setItems(items.filter((_, i) => i !== idx));

  const orderTotal = Number((items.length ? items.reduce((sum, i) => sum + (parseFloat(i.price) || 0) * (parseFloat(i.quantity) || 0), 0) : (parseFloat(form.order_total)||0)).toFixed(2));
  const checkBenefits=async()=>{
    const version=++benefitVersion.current;setQuoting(true);setBenefitQuote(null);
    try{const {data}=await promotionsAPI.quote({phone:form.phone,order_total:orderTotal.toFixed(2),hold_amount:Number(form.hold_amount||0).toFixed(2),promo_code:form.promo_code||null,place_id:form.place_id||null,items:items.map(i=>({product_id:i.product_id||null,price:i.price,quantity:i.quantity})),product_ids:items.filter(i=>i.product_id).map(i=>i.product_id)});if(version===benefitVersion.current)setBenefitQuote(data);}
    catch(e){toast.error(typeof e.response?.data?.detail==='string'?e.response.data.detail:'Не удалось проверить выгоды');}
    finally{setQuoting(false);}
  };

  const checkGift=async()=>{
    const version=++giftVersion.current;setGiftBusy(true);setGiftChecked(null);
    try{const {data}=await growthAPI.quote({code:form.gift_card_code,amount:Number(form.gift_card_amount||0).toFixed(2)});if(version===giftVersion.current)setGiftChecked(data);}
    catch(e){toast.error(typeof e.response?.data?.detail==='string'?e.response.data.detail:'Не удалось проверить карту');}
    finally{setGiftBusy(false);}
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (orderTotal <= 0) { toast.error('Добавьте товары или укажите сумму'); return; }
    if((form.gift_card_code||Number(form.gift_card_amount))&&!giftChecked){toast.error('Сначала проверьте подарочную карту');return;}
    if(applyPromotions&&!benefitQuote){toast.error('Сначала проверьте выгоды');return;}
    setLoading(true);
    try {
      await ordersAPI.create({
        referral_code:form.referral_code||null,
        gift_card_code:form.gift_card_code||null,
        gift_card_amount:Number(form.gift_card_amount||0),
        place_id:form.place_id||null,
        apply_promotions:applyPromotions,
        benefit_quote_sha:applyPromotions?benefitQuote.sha256:null,
        phone: form.phone,
        order_total: orderTotal,
        hold_amount: parseFloat(form.hold_amount) || 0,
        promo_code: form.promo_code || null,
        external_order_id: form.external_order_id || null,
        items: items.length > 0 ? items.map(i => ({
          product_id: i.product_id || null,
          name: i.name,
          price: parseFloat(i.price) || 0,
          quantity: parseFloat(i.quantity) || 1,
        })) : null,
      });
      toast.success('Заказ создан');
      onCreated();
      onClose();
    } catch (err) {
      if(err.response?.status===409)setBenefitQuote(null);
      toast.error(err.response?.data?.detail || 'Ошибка');
    } finally { setLoading(false); }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={e => e.stopPropagation()} style={{ maxWidth: 720 }}>
        <h2 className="modal-title">Новый заказ</h2>
        <form onSubmit={handleSubmit}>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
            <div className="form-group">
              <label className="form-label">Телефон клиента *</label>
              <input className="form-input" required placeholder="+79001234567"
                value={form.phone} onChange={e => setForm({ ...form, phone: e.target.value })} />
            </div>
            <div className="form-group">
              <label className="form-label">Внешний ID заказа</label>
              <input className="form-input" placeholder="ORD-12345"
                value={form.external_order_id}
                onChange={e => setForm({ ...form, external_order_id: e.target.value })} />
            </div>
          </div>

          <div className="form-group">
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
              <label className="form-label" style={{ marginBottom: 0 }}>Состав заказа</label>
              <button type="button" className="btn btn-ghost btn-sm" onClick={addItem}>
                <Plus size={14} /> Добавить товар
              </button>
            </div>
            {items.map((item, idx) => {
              const productOptions = products.map(p => ({
                value: p.id, label: p.name, sublabel: `${p.external_id} · ${p.price || 0} ₽`,
              }));
              if (item.product_id && !productOptions.find(o => o.value === item.product_id)) {
                productOptions.unshift({
                  value: item.product_id,
                  label: item._product?.name || item.name || 'Товар',
                  sublabel: item._product ? `${item._product.external_id} · ${item._product.price || 0} ₽` : '',
                });
              }
              return (
                <div key={idx} style={{ display: 'grid', gridTemplateColumns: '1fr 90px 70px 32px', gap: 8, marginBottom: 8, alignItems: 'start' }}>
                  <SearchableSelect
                    value={item.product_id}
                    onChange={v => updateItem(idx, 'product_id', v)}
                    onSearch={setProductSearch}
                    placeholder="Товар из каталога..."
                    options={productOptions}
                  />
                  <input className="form-input" type="number" placeholder="Цена" min="0" step="0.01"
                    value={item.price} onChange={e => updateItem(idx, 'price', e.target.value)} />
                  <input className="form-input" type="number" placeholder="Кол-во" min="1" step="1"
                    value={item.quantity} onChange={e => updateItem(idx, 'quantity', parseInt(e.target.value) || 1)} />
                  <button type="button" className="btn btn-ghost btn-sm" onClick={() => removeItem(idx)}>
                    <Trash2 size={14} />
                  </button>
                </div>
              );
            })}
            {items.length === 0 && (
              <div style={{ fontSize: 12, color: 'var(--text-muted)', padding: 12, textAlign: 'center', background: 'var(--bg-secondary)', borderRadius: 'var(--radius-sm)' }}>
                Без товаров — укажите общую сумму ниже
              </div>
            )}
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
            <div className="form-group">
              <label className="form-label">Сумма заказа</label>
              <input className="form-input" type="number" min="0" step="0.01" required={items.length === 0}
                value={items.length > 0 ? orderTotal.toFixed(2) : (form.order_total || '')}
                disabled={items.length > 0}
                onChange={e => setForm({ ...form, order_total: e.target.value })} />
            </div>
            <div className="form-group">
              <label className="form-label">Списать баллов</label>
              <input className="form-input" type="number" min="0" step="0.01"
                value={form.hold_amount} onChange={e => setForm({ ...form, hold_amount: e.target.value })} />
            </div>
          </div>

          <div className="form-group">
            <label className="form-label">Промокод</label>
            <input className="form-input" placeholder="WELCOME"
              value={form.promo_code} onChange={e => setForm({ ...form, promo_code: e.target.value })} />
          </div>

          <details className="order-benefit-box order-growth-box"><summary>Приглашение друга и подарочная карта</summary><label style={{marginTop:12}}>Код пригласившего · до первого заказа<input className="form-input" value={form.referral_code||''} maxLength={32} onChange={e=>setForm({...form,referral_code:e.target.value})}/></label><label style={{marginTop:12}}>Код подарочной карты<input className="form-input" autoComplete="off" value={form.gift_card_code||''} maxLength={64} onChange={e=>setForm({...form,gift_card_code:e.target.value})}/></label><label style={{marginTop:12}}>Списать с подарочной карты, ₽<input className="form-input" type="number" min="0" max="100000" step="0.01" value={form.gift_card_amount||''} onChange={e=>setForm({...form,gift_card_amount:e.target.value})}/></label><button type="button" className="btn btn-ghost btn-sm" disabled={giftBusy||!form.gift_card_code||!(Number(form.gift_card_amount)>0)} onClick={checkGift}>{giftBusy?'Проверяем…':'Проверить подарочную карту'}</button>{giftChecked&&<p>Карта {giftChecked.mask}: доступно {Number(giftChecked.available).toLocaleString('ru-RU')} ₽. К списанию {Number(giftChecked.requested).toLocaleString('ru-RU')} ₽.</p>}<p style={{fontSize:12,color:'var(--text-muted)'}}>Сумма карты вместе с бонусами не может превышать сумму после скидки. Деньгами: {Math.max(0,Number(benefitQuote?.net??orderTotal)-Number(form.hold_amount||0)-Number(form.gift_card_amount||0)).toLocaleString('ru-RU')} ₽.</p></details>
          <div className="order-benefit-box"><label><input type="checkbox" checked={applyPromotions} onChange={e=>setApplyPromotions(e.target.checked)}/>Учитывать акции и выбрать выгоду</label>{applyPromotions&&<><label style={{marginTop:12}}>Точка продаж<select className="form-input" value={form.place_id||''} onChange={e=>setForm({...form,place_id:e.target.value})}><option value="">Не указана</option>{benefitPlaces.map(p=><option value={p.id} key={p.id}>{p.name}</option>)}</select></label><button type="button" className="btn btn-ghost btn-sm" disabled={quoting||!form.phone||orderTotal<=0} onClick={checkBenefits}>{quoting?'Проверяем…':'Проверить выгоды'}</button>{benefitQuote&&<div className="order-benefit-result"><strong>{benefitQuote.winner?.name||'Без скидки'}</strong><RewardDescription winner={benefitQuote.winner}/><span>Скидка: {Number(benefitQuote.discount).toLocaleString('ru-RU')} ₽ · После скидки: {Number(benefitQuote.net).toLocaleString('ru-RU')} ₽ · Деньгами: {Number(benefitQuote.payable).toLocaleString('ru-RU')} ₽</span></div>}</>}</div>
          <div className="modal-actions">
            <button type="button" className="btn btn-ghost" onClick={onClose}>Отмена</button>
            <button type="submit" className="btn btn-primary" disabled={loading||quoting||giftBusy||(applyPromotions&&!benefitQuote)||((!!form.gift_card_code||!!Number(form.gift_card_amount))&&!giftChecked)}>
              {loading ? '...' : 'Создать заказ'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}


function OrderDetailModal({ orderId, onClose, onChanged, previousId, nextId, onNavigate }) {
  const {user}=useAuth();
  const canReturn=["owner","operator"].includes(user?.role);
  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);
  const [actionLoading, setActionLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    let alive=true;setLoading(true);setOrder(null);
    ordersAPI.get(orderId).then(r => {if(alive)setOrder(r.data);}).catch(() => toast.error('Ошибка загрузки')).finally(() => {if(alive)setLoading(false);});
    return()=>{alive=false;};
  }, [orderId]);

  const handleConfirm = async () => {
    setActionLoading(true);
    try {
      await ordersAPI.confirm(orderId);
      toast.success('Заказ подтверждён');
      const r = await ordersAPI.get(orderId); setOrder(r.data);
      onChanged?.();
    } catch (err) { toast.error(err.response?.data?.detail || 'Ошибка'); }
    finally { setActionLoading(false); }
  };

  const handleCancel = async () => {
    if (!window.confirm('Отменить заказ?')) return;
    setActionLoading(true);
    try {
      await ordersAPI.cancel(orderId);
      toast.success('Заказ отменён');
      const r = await ordersAPI.get(orderId); setOrder(r.data);
      onChanged?.();
    } catch (err) { toast.error(err.response?.data?.detail || 'Ошибка'); }
    finally { setActionLoading(false); }
  };

  const goToClient = () => {
    window.open(`/clients?client_id=${order.client_id}`, '_blank');
  };

  if (loading) return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={e => e.stopPropagation()}><div style={{ padding: 40, textAlign: 'center', color: 'var(--text-muted)' }}>Загрузка...</div></div>
    </div>
  );

  if (!order) return <div className="modal-overlay"><div className="modal" role="dialog" aria-modal="true" aria-label="Заказ недоступен"><p role="alert">Не удалось загрузить заказ.</p><button className="btn btn-ghost" onClick={onClose}>Закрыть</button></div></div>;

  const statusMap = {
    held: { text: 'Ожидает подтверждения', cls: 'badge-warning' },
    confirmed: { text: 'Подтверждён', cls: 'badge-success' },
    cancelled: { text: 'Отменён', cls: 'badge-danger' },
  };
  if(order.return_count>0)statusMap[order.status]={text:order.status==='cancelled'?'Возвращён':'Частичный возврат',cls:order.status==='cancelled'?'badge-danger':'badge-warning'};
  const stMeta = statusMap[order.status] || { text: order.status, cls: 'badge-info' };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div onClick={e => e.stopPropagation()} style={{ maxWidth: 1020 }} className="modal purchase-modal" role="dialog" aria-modal="true" aria-labelledby="purchase-title">
        <header className="purchase-header"><div><h2 className="modal-title" id="purchase-title">Заказ #{order.id.slice(0,8)}</h2><span className={`badge ${stMeta.cls}`}>{stMeta.text}</span></div><button className="btn btn-ghost btn-sm" aria-label="Закрыть карточку заказа" disabled={actionLoading} onClick={onClose}><X size={18}/></button></header>
        <OrderPurchaseDetails key={order.id} order={order} onClient={goToClient}/>
        <div className="modal-actions purchase-actions">
          {onNavigate&&<div className="purchase-navigation"><button className="btn btn-ghost btn-sm" aria-label="Предыдущий заказ" disabled={!previousId||actionLoading} onClick={()=>onNavigate(previousId)}><ChevronLeft size={16}/></button><button className="btn btn-ghost btn-sm" aria-label="Следующий заказ" disabled={!nextId||actionLoading} onClick={()=>onNavigate(nextId)}><ChevronRight size={16}/></button></div>}
          <button type="button" className="btn btn-ghost" onClick={onClose}>Закрыть</button>
          {(canReturn&&order.status==='confirmed'||order.return_count>0)&&<button className="btn btn-ghost" onClick={()=>navigate('/returns?order_id='+order.id)}>{canReturn&&order.status==='confirmed'?'Оформить возврат':'История возвратов'}</button>}
          {canReturn && order.status === 'held' && (
            <>
              <button className="btn btn-danger" disabled={actionLoading} onClick={handleCancel}>
                <XCircle size={14} /> Отменить
              </button>
              <button className="btn btn-success" disabled={actionLoading} onClick={handleConfirm}>
                <CheckCircle size={14} /> Подтвердить
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

function ImportOrdersModal({ onClose, onImported }) {
  const [file, setFile] = useState(null);
  const [accrueBonuses, setAccrueBonuses] = useState(false);
  const [defaultStatus, setDefaultStatus] = useState('confirmed');
  const [loading, setLoading] = useState(false);
  const [taskId, setTaskId] = useState(null);
  const [progress, setProgress] = useState(null);
  const [status, setStatus] = useState(null);

  useEffect(() => {
    if (!taskId) return;
    const interval = setInterval(async () => {
      try {
        const res = await ordersAPI.importStatus(taskId);
        setProgress(res.data.progress);
        setStatus(res.data.status);
        if (res.data.status === 'success' || res.data.status === 'failed') {
          clearInterval(interval);
          setLoading(false);
          if (res.data.status === 'success') {
            toast.success(`Создано: ${res.data.progress?.created || 0}`);
            onImported();
          } else {
            toast.error(res.data.message || 'Ошибка');
          }
        }
      } catch { clearInterval(interval); setLoading(false); }
    }, 2000);
    return () => clearInterval(interval);
  }, [taskId]);

  const handleImport = async () => {
    if (!file) { toast.error('Выберите CSV файл'); return; }
    setLoading(true); setProgress(null); setStatus(null);
    try {
      const formData = new FormData();
      formData.append('file', file);
      const res = await ordersAPI.importCSV(formData, accrueBonuses, defaultStatus);
      setTaskId(res.data.task_id);
    } catch (err) { toast.error(err.response?.data?.detail || 'Ошибка импорта'); setLoading(false); }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={e => e.stopPropagation()} style={{ maxWidth: 520 }}>
        <h2 className="modal-title">Импорт заказов из CSV</h2>
        <div className="form-group">
          <label className="form-label">CSV файл</label>
          <input type="file" accept=".csv,.txt,.tsv" onChange={e => setFile(e.target.files[0])}
            className="form-input" style={{ padding: 8 }} />
        </div>
        <div style={{ fontSize: 11, color: 'var(--text-muted)', marginBottom: 12, lineHeight: 1.6 }}>
          Колонки: <code>телефон</code> (обяз.) · <code>сумма</code> (обяз.) · <code>дата покупки</code> · <code>магазин</code> · <code>номер заказа</code> · <code>промокод</code><br/>
          Дубли определяются по номеру заказа или по (клиент + сумма + дата). Точки продаж создаются автоматически.
        </div>
        <div className="form-group" style={{ marginBottom: 12 }}>
          <label className="form-label">Статус заказов по умолчанию</label>
          <select className="form-input" value={defaultStatus} onChange={e => setDefaultStatus(e.target.value)}>
            <option value="confirmed">Подтверждён</option>
            <option value="held">В ожидании</option>
            <option value="cancelled">Отменён</option>
          </select>
          <div style={{ fontSize: 10, color: 'var(--text-muted)', marginTop: 2 }}>Применяется если в файле нет колонки «статус»</div>
        </div>
        <label style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer', marginBottom: 16 }}>
          <input type="checkbox" checked={accrueBonuses} onChange={e => setAccrueBonuses(e.target.checked)} />
          <span style={{ fontSize: 13 }}>Начислять бонусы за заказы</span>
        </label>
        {(loading || (progress && status)) && (
          <div style={{ padding: 12, background: 'var(--bg-secondary)', borderRadius: 'var(--radius-sm)', marginBottom: 12, fontSize: 12 }}>
            {loading && <div style={{ marginBottom: 6 }}>{status === 'running' ? '⏳ Импорт выполняется...' : '⏳ Запуск...'}</div>}
            {!loading && status === 'success' && <div style={{ color: 'var(--success)', fontWeight: 600, marginBottom: 6 }}>Импорт завершён</div>}
            {!loading && status === 'failed' && <div style={{ color: 'var(--danger)', fontWeight: 600, marginBottom: 6 }}>Ошибка</div>}
            {progress && <>
              <div>Создано: <strong style={{ color: 'var(--success)' }}>{progress.created || 0}</strong></div>
              <div>Пропущено (дубли): <strong>{progress.skipped || 0}</strong></div>
              {progress.places_created > 0 && <div>Точек создано: <strong>{progress.places_created}</strong></div>}
              {progress.errors?.length > 0 && <div style={{ marginTop: 6, color: 'var(--danger)', fontSize: 11 }}>
                {progress.errors.slice(0, 5).map((e, i) => <div key={i}>{e}</div>)}
              </div>}
            </>}
          </div>
        )}
        <div className="modal-actions">
          <button type="button" className="btn btn-ghost" onClick={onClose}>Закрыть</button>
          <button className="btn btn-primary" onClick={handleImport} disabled={loading || !file}>
            {loading ? 'Импорт...' : 'Импортировать'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default function OrdersPage() {
  const [searchParams,setSearchParams] = useSearchParams();
  const driverKey=[searchParams.get("chain_ids")||"",searchParams.get("campaign_ids")||""].join("|");
  const urlDrivers=()=>({chain_ids:(searchParams.get("chain_ids")||"").split(",").filter(Boolean),campaign_ids:(searchParams.get("campaign_ids")||"").split(",").filter(Boolean),date_from:searchParams.get('date_from')||'',date_to:searchParams.get('date_to')||'',status:searchParams.get('status')||'',rfm_segments:(searchParams.get('rfm_segments')||'').split(',').filter(Boolean),saved_segment:searchParams.get('saved_segment')||''});
  const clientFilterId = searchParams.get('client_id');

  const [showCreate, setShowCreate] = useState(false);
  const [showImport, setShowImport] = useState(false);
  const [viewOrderId, setViewOrderId] = useState(searchParams.get('order_id'));
  const [orders, setOrders] = useState([]);
  const [total, setTotal] = useState(null);
  const [loading, setLoading] = useState(true);
  const [loadError, setLoadError] = useState('');
  const requestId = useRef(0);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(100);
  const [search, setSearch] = useState('');
  const [orderFilters, setOrderFilters] = useState(()=>({...EMPTY_ORDER_FILTERS,...urlDrivers()}));
  const [attributionSources,setAttributionSources]=useState([]),[filteredAmount,setFilteredAmount]=useState(null);
  const hasDrivers=!!(orderFilters.chain_ids?.length||orderFilters.campaign_ids?.length);
  const clientOnly=!!clientFilterId&&!hasDrivers;
  useEffect(()=>{const d=urlDrivers();if(Object.keys(d).every(k=>JSON.stringify(d[k])===JSON.stringify(orderFilters[k]??(Array.isArray(d[k])?[]:''))))return;setLoading(true);setOrders([]);setTotal(null);setAttributionSources([]);setFilteredAmount(null);setOrderFilters(v=>({...v,...d}));setActiveQuery(v=>({...v,filters:{...orderFilters,...d}}));setPage(1);},[driverKey]);
  const applyOrderFilters=next=>{setLoading(true);setOrderFilters(next);const p=new URLSearchParams(searchParams);for(const key of ["chain_ids","campaign_ids"]){if(next[key]?.length)p.set(key,next[key].join(","));else p.delete(key);}setSearchParams(p,{replace:true});};
  const [activeQuery, setActiveQuery] = useState({ search: '', filters: orderFilters });
  const navigate = useNavigate();

  const buildDateFrom = (orderFilters) => {
    if (orderFilters.date_from) return orderFilters.date_from;
    if (orderFilters.periodDays !== null && orderFilters.periodDays !== undefined) {
      const d = new Date(); d.setDate(d.getDate() - orderFilters.periodDays);
      return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`;
    }
    return '';
  };

  const loadAll = (p = page) => {
    const id = ++requestId.current;
    setLoading(true);
    setLoadError('');
    const { search: q, filters: orderFilters } = activeQuery;
    const skip = (p - 1) * pageSize;
    const df = buildDateFrom(orderFilters);
    const f = {
      chain_ids: orderFilters.chain_ids?.length?orderFilters.chain_ids.join(","):undefined,
      campaign_ids: orderFilters.campaign_ids?.length?orderFilters.campaign_ids.join(","):undefined,
      client_id: clientFilterId&&hasDrivers?clientFilterId:undefined,
      status: orderFilters.status || undefined,
      saved_segment:orderFilters.saved_segment||undefined,
      exclude_place_ids: orderFilters.exclude_place_ids?.length ? orderFilters.exclude_place_ids.join(',') : undefined,
      exclude_rfm_segments: orderFilters.exclude_rfm_segments?.length ? orderFilters.exclude_rfm_segments.join(',') : undefined,
      place_ids: orderFilters.place_ids?.length ? orderFilters.place_ids.join(',') : undefined,
      date_from: df || undefined,
      date_to: orderFilters.date_to || undefined,
      min_total: orderFilters.min_total === '' ? undefined : orderFilters.min_total,
      max_total: orderFilters.max_total === '' ? undefined : orderFilters.max_total,
      client_type: orderFilters.client_type || undefined,
      source: orderFilters.source || undefined,
      rfm_segments: orderFilters.rfm_segments?.length ? orderFilters.rfm_segments.join(',') : undefined,
    };
    const request = clientOnly ? ordersAPI.byClient(clientFilterId) : ordersAPI.all(skip, pageSize, q || null, f);
    return request.then(res => {
      if (id !== requestId.current) return;
      setOrders(clientOnly ? res.data : res.data.items);
      setTotal(clientOnly ? res.data.length : res.data.total);
      setAttributionSources(res.data.attribution_sources||[]);setFilteredAmount(res.data.filtered_amount??null);
    }).catch(() => {
      if (id === requestId.current) setLoadError('Не удалось загрузить заказы. Повторите попытку.');
    }).finally(() => {
      if (id === requestId.current) setLoading(false);
    });
  };

  useEffect(() => {
    loadAll(page);
    return () => { ++requestId.current; };
  }, [page, pageSize, clientFilterId, activeQuery]);

  const queryKey = JSON.stringify({ search, filters: orderFilters });
  useEffect(() => {
    if (clientOnly || queryKey === JSON.stringify(activeQuery)) return;
    const t = setTimeout(() => {
      setPage(1);
      setActiveQuery(JSON.parse(queryKey));
    }, 400);
    return () => clearTimeout(t);
  }, [queryKey, clientOnly]);

  const totalPages = clientOnly ? 1 : Math.ceil((total || 0) / pageSize);

  const statusBadge = (status,returns=0) => {
    const map = {
      held: { text: 'Ожидает', cls: 'badge-warning' },
      confirmed: { text: 'Подтверждён', cls: 'badge-success' },
      cancelled: { text: 'Отменён', cls: 'badge-danger' },
    };
    if(returns>0)map[status]={text:status==='cancelled'?'Возвращён':'Частичный возврат',cls:status==='cancelled'?'badge-danger':'badge-warning'};
    const m = map[status] || { text: status, cls: 'badge-info' };
    return <span className={`badge ${m.cls}`}>{m.text}</span>;
  };

  return (
    <div className="animate-in">
      <div className="page-header">
        <h1 className="page-title">Заказы</h1>
        <p className="page-subtitle">{total === null ? (loadError ? 'Количество недоступно' : 'Загружаем заказы…') : `Всего: ${total}`}{clientFilterId && ' (фильтр по клиенту)'}</p>
      </div>

      <div className="page-actions" style={{marginBottom:16}}>
        <button className="btn btn-primary" onClick={() => setShowCreate(true)}><ShoppingCart size={16}/>Новый заказ</button>
        <button className="btn btn-ghost" onClick={() => setShowImport(true)}>Импорт CSV</button>
      </div>
      {clientOnly ? <div style={{marginBottom:16}}><button className="btn btn-ghost" onClick={()=>navigate('/orders')}>Сбросить фильтр по клиенту</button></div> :
        <OrderFilters value={orderFilters} onApply={applyOrderFilters} sourceOptions={attributionSources}>
          <input className="form-input orders-filter-search" placeholder="Поиск по ID, телефону, имени, промокоду…" aria-label="Поиск заказов" value={search} onChange={e=>setSearch(e.target.value)}/>
        </OrderFilters>}

      {hasDrivers&&<div className="orders-attribution-note" role="note" style={{marginBottom:16,fontSize:12,color:'var(--text-secondary)'}}>
        {loading?'Обновляем выборку источника…':loadError?'Выборка источника недоступна. Фильтр не сброшен.':<>Покупки, учтённые в выручке: {attributionSources.map(s=>s.name).join(' или ')}.{filteredAmount!==null&&<> Сумма выборки: <strong>{Number(filteredAmount).toLocaleString('ru-RU',{maximumFractionDigits:0})} ₽</strong>.</>} Остальные фильтры сужают список; один заказ показывается один раз.</>}
      </div>}
      <div className="table-container">
        <table className="table">
          <thead>
            <tr>
              <th>Дата</th>
              <th>Внешний ID</th>
              <th>Клиент</th>
              <th>Сумма</th>
              <th>Товаров</th>
              <th>Списание</th>
              <th>Кешбэк</th>
              <th>Точка продаж</th>
              <th>Статус</th>
              <th></th>
            </tr>
          </thead>
          <tbody aria-busy={loading}>
            {loading && <tr><td colSpan={10} role="status" style={{ padding: 16, color: 'var(--text-muted)' }}>{orders.length ? 'Обновляем список…' : 'Загружаем заказы…'}</td></tr>}
            {loadError && <tr><td colSpan={10} role="alert" style={{ padding: 16 }}>{loadError} <button className="btn btn-sm" onClick={() => loadAll(page)}>Повторить</button></td></tr>}
            {orders.map(o => (
              <tr key={o.id} style={{ cursor: 'pointer' }} onClick={() => setViewOrderId(o.id)}>
                <td style={{ fontSize: 12 }}>{new Date(o.created_at).toLocaleString('ru')}</td>
                <td style={{ fontFamily: 'var(--font-mono)', fontSize: 11 }}>{o.external_order_id || '—'}</td>
                <td>
                  {o.client_name && <div>{o.client_name}</div>}
                  <div style={{ fontSize: 11, color: 'var(--text-muted)', fontFamily: 'var(--font-mono)' }}>{o.client_phone || '—'}</div>
                </td>
                <td style={{ fontFamily: 'var(--font-mono)', fontWeight: 600, whiteSpace: 'nowrap' }}>{o.order_total.toLocaleString('ru')} ₽</td>
                <td style={{ textAlign: 'center', color: 'var(--text-muted)' }}>{o.items_count || 0}</td>
                <td style={{ fontFamily: 'var(--font-mono)' }}>{o.hold_amount.toLocaleString('ru')}</td>
                <td style={{ fontFamily: 'var(--font-mono)', color: 'var(--success)' }}>+{o.cashback_amount.toLocaleString('ru')}</td>
                <td style={{ fontSize: 11 }}>
                  <span className="badge">{o.place_name || ({website:'Сайт',app:'Приложение',offline:'Розничная точка',marketplace:'Маркетплейс',crm:'Битрикс24'}[o.source]) || 'Не передана'}</span>
                </td>
                <td>{statusBadge(o.status,o.return_count)}</td>
                <td>
                  <button className="btn btn-ghost btn-sm" onClick={e => { e.stopPropagation(); setViewOrderId(o.id); }}>
                    <Eye size={14} />
                  </button>
                </td>
              </tr>
            ))}
            {!loading && !loadError && total !== null && orders.length === 0 && (
              <tr><td colSpan={10} style={{ textAlign: 'center', padding: 40, color: 'var(--text-muted)' }}>
                {search || Object.values(orderFilters).some(v=>Array.isArray(v)?v.length:v!==''&&v!==null&&v!==undefined&&v!==false) ? 'По выбранным условиям заказы не найдены' : 'Заказов пока нет'}
              </td></tr>
            )}
          </tbody>
        </table>
      </div>

      {!clientOnly && <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',gap:16,flexWrap:'wrap',marginTop:16}}>
        <label style={{display:'flex',alignItems:'center',gap:8,fontSize:13,color:'var(--text-secondary)'}}>Заказов на странице
          <select className="form-input" aria-label="Заказов на странице" style={{width:90}} value={pageSize} onChange={e=>{setLoading(true);setPage(1);setPageSize(Number(e.target.value));}}>
            {PAGE_SIZES.map(size=><option key={size} value={size}>{size}</option>)}
          </select>
        </label>
        <span style={{fontSize:13,color:'var(--text-muted)'}}>{total!==null&&!loading&&!loadError&&total>0?`${(page-1)*pageSize+1}–${Math.min(page*pageSize,total)} из ${total.toLocaleString('ru-RU')}`:''}</span>
      </div>}
      <Pagination page={page} totalPages={totalPages} onPageChange={setPage} />

      {showCreate && <CreateOrderModal onClose={() => setShowCreate(false)} onCreated={() => loadAll(page)} />}
      {viewOrderId && <OrderDetailModal previousId={orders[orders.findIndex(o=>o.id===viewOrderId)-1]?.id} nextId={orders.findIndex(o=>o.id===viewOrderId)>=0?orders[orders.findIndex(o=>o.id===viewOrderId)+1]?.id:undefined} onNavigate={setViewOrderId} orderId={viewOrderId} onClose={() => setViewOrderId(null)} onChanged={() => loadAll(page)} />}
      {showImport && <ImportOrdersModal onClose={() => setShowImport(false)} onImported={() => loadAll(1)} />}
    </div>
  );
}